import { render } from "./BaseTable.vue?vue&type=template&id=2c5eec4d&scoped=true"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=2c5eec4d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5eec4d"],['__file',"src/common/components/BaseTable/BaseTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c5eec4d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c5eec4d', __exports__)) {
    api.reload('2c5eec4d', __exports__)
  }
  
  module.hot.accept("./BaseTable.vue?vue&type=template&id=2c5eec4d&scoped=true", () => {
    api.rerender('2c5eec4d', render)
  })

}


export default __exports__